import styled from 'styled-components';

export const CheckboxContainer = styled.div<{ disabled?: boolean }>`
  position: relative;
  display: inline-block;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

export const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 20px;
  width: 20px;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
`;

export const Checkmark = styled.div<{ checked: boolean; disabled?: boolean }>`
  height: 20px;
  width: 20px;
  background-color: ${({ checked, disabled }) =>
    checked
      ? '#6C5CE7'
      : disabled
        ? '#E9ECEF'
        : '#FFFFFF'
  };
  border: 2px solid ${({ checked, disabled }) =>
    checked
      ? '#6C5CE7'
      : disabled
        ? '#E9ECEF'
        : '#DEE2E6'
  };
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: ${({ checked, disabled }) =>
    checked
      ? '#5B4CDB'
      : disabled
        ? '#E9ECEF'
        : '#6C5CE7'
  };
  }

  &:active {
    transform: scale(0.95);
  }
`;
